import { useTranslation } from "lib/i18n/translation"

export default ({ list }) => {
	const { c } = useTranslation("common")

	return (
		<section>
			<h2 className="section-title icon-user">{c("life-list-title")}</h2>
			<div dangerouslySetInnerHTML={{ __html: c(`life-list-text-${list.id}`)}}/>
		</section>
	)
}
